import { useEffect } from 'react';

export const useDebounceEffect = (debounceCallback, dependencies) => (delay) => useEffect(() => {
  const handler = setTimeout(() => {
    debounceCallback();
  }, delay);

  return () => clearTimeout(handler);
}, dependencies);

export default useDebounceEffect;
